import { Component, Input, Output, OnInit, TemplateRef, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  RegistrationStepQuery,
  RegistrationStepService,
  RegistrationStepSettings,
  StepType,
  TermsAndConditionsType,
} from '@fgb/core';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'fgbcl-registration-terms-and-conditions',
  templateUrl: './registration-terms-and-conditions.component.html',
  styleUrls: ['./registration-terms-and-conditions.component.scss'],
})
export class RegistrationTermsAndConditionsComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType;
  readonly stepType = StepType.TermsAndConditions;
  accepted: boolean = false;
  isButtonHidden: boolean = false;
  showScrollButton: boolean = false;
  @Input() loading: TemplateRef<any>;
  @Output() acceptedCheckbox: EventEmitter<boolean> = new EventEmitter(false);
  @ViewChild('content', { static: false }) content: ElementRef<any>;
  @ViewChild('bottom', { static: false }) bottom: ElementRef<any>;
  @HostListener('window:scroll', ['$event']) onWindowScroll(event: Event): void {
    if (this.showScrollButton) {
      this.isButtonHidden = window.scrollY + window.innerHeight > this.bottom.nativeElement.offsetTop;
    }
  }
  settings: RegistrationStepSettings;

  constructor(
    private registrationStepService: RegistrationStepService,
    private route: ActivatedRoute,
    private registrationStepQuery: RegistrationStepQuery
  ) {
    if (this.route.snapshot.data.showBottomButton) {
      this.showScrollButton = this.route.snapshot.data.showBottomButton;
    }
  }

  ngOnInit() {
    const settings = this.registrationStepQuery.getStepSettings(this.stepType) as RegistrationStepSettings;
    this.termsAndConditionsType = settings?.Type || TermsAndConditionsType.General;
    lastValueFrom(this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType, true));
  }

  handleCheckboxClick() {
    this.acceptedCheckbox.emit(this.accepted);
  }

  submitStep() {
    this.registrationStepService
      .submitRegistrationStepData(this.stepType, { Accepted: this.accepted, TermsAndConditions: null })
      .toPromise();
  }

  scrollToBottom(): void {
    this.bottom.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  onScroll(event: Event): void {
    if (this.showScrollButton) {
      this.isButtonHidden =
        this.content.nativeElement.scrollTop + this.content.nativeElement.clientHeight >= this.content.nativeElement.scrollHeight;
    }
  }
}
